import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyZipCode = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      itemColumnEnd={4}
      itemColumnStart={1}
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.address.pobox.label')}
      name="companyZipCode"
      render={({ field }) => {
        return <Input {...field} size="sm" />
      }}
    />
  )
}
